// @file Vue composable for QR code logic used by Slideshow
import { trackEvent } from '@@/bits/analytics'
import { useSlideshowStore } from '@@/pinia/slideshow'
import { storeToRefs } from 'pinia'
import type { Ref } from 'vue'

export const useSlideshowQRCode = (): {
  isQrCodeShown: Ref<boolean>
  shouldRemoveQrCode: Ref<boolean>
  toggleQRCode: () => void
} => {
  const slideshowStore = useSlideshowStore()
  const { isQrCodeShown, shouldRemoveQrCode } = storeToRefs(slideshowStore)

  const toggleQRCode = (): void => {
    isQrCodeShown.value = !isQrCodeShown.value
    trackEvent('Slideshow', isQrCodeShown.value ? 'Show QR code' : 'Hide QR code')
  }

  return {
    isQrCodeShown,
    shouldRemoveQrCode,

    toggleQRCode,
  }
}
